export default {
  fields: {
    username: {
      id: 1,
      name: "username",
      label: "loginUsername",
      errorMessage: "loginUsernameRequired",
      value: '',
      defaultValue: null,
    },
    password: {
      id: 2,
      name: "password",
      label: "loginPassword",
      errorMessage: "loginPasswordRequired",
      value: '',
      defaultValue: null,
    }
  }
}
